import type { InputHTMLAttributes, ReactNode } from "react";

/** Поле формы (A0): подпись mono 11px, поле на --bg2, ошибка — красная подпись и подсказка. */
export function Field({
  label,
  hint,
  error,
  id,
  className = "",
  ...input
}: InputHTMLAttributes<HTMLInputElement> & { label: string; hint?: ReactNode; error?: ReactNode }) {
  const inputId = id ?? `f-${label.replace(/\W+/g, "-")}`;
  return (
    <label htmlFor={inputId} className={`flex flex-col gap-1.5 ${className}`}>
      <span className={`font-mono text-[11px] tracking-[.04em] ${error ? "text-err" : "text-mut"}`}>{label}</span>
      <input
        id={inputId}
        aria-invalid={error ? true : undefined}
        className={`rounded-sm border px-[11px] py-[9px] font-mono text-[13px] text-ink outline-none focus:border-acc ${
          error ? "border-err bg-errsoft" : "border-bd2 bg-bg2"
        }`}
        {...input}
      />
      {error ? (
        <span className="font-mono text-[11px] text-err">{error}</span>
      ) : hint ? (
        <span className="font-mono text-[11px] text-mut">{hint}</span>
      ) : null}
    </label>
  );
}
